/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  VektorChestContentsRequestDto,
  VektorChestIndexRequestDto,
  VektorChestObservationRequestDto,
  VektorGogglesListBotsParams,
  VektorGogglesListOverlaysParams,
  VektorGogglesStreamOverlaysParams,
  VektorHandshakeRequestDto,
  VektorSchematicSubmitRequestDto
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type vektorGogglesHandshakeResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesHandshakeResponseSuccess = (vektorGogglesHandshakeResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesHandshakeResponse = (vektorGogglesHandshakeResponseSuccess)

export const getVektorGogglesHandshakeUrl = () => {




  return `/api/vektor/handshake`
}

export const useVektorGogglesHandshakeHook = (): (vektorHandshakeRequestDto?: VektorHandshakeRequestDto, options?: RequestInit) => Promise<vektorGogglesHandshakeResponse> => {

      const customFetcher = useSfetchMutator();
      return (vektorHandshakeRequestDto?: VektorHandshakeRequestDto, options?: RequestInit) => {

        return customFetcher(getVektorGogglesHandshakeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vektorHandshakeRequestDto)
  }
);
      }
  }


export type vektorGogglesHandshakeDevResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesHandshakeDevResponseSuccess = (vektorGogglesHandshakeDevResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesHandshakeDevResponse = (vektorGogglesHandshakeDevResponseSuccess)

export const getVektorGogglesHandshakeDevUrl = () => {




  return `/api/vektor/handshake/dev`
}

export const useVektorGogglesHandshakeDevHook = (): ( options?: RequestInit) => Promise<vektorGogglesHandshakeDevResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorGogglesHandshakeDevUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type vektorGogglesMeResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesMeResponseSuccess = (vektorGogglesMeResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesMeResponse = (vektorGogglesMeResponseSuccess)

export const getVektorGogglesMeUrl = () => {




  return `/api/vektor/me`
}

export const useVektorGogglesMeHook = (): ( options?: RequestInit) => Promise<vektorGogglesMeResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorGogglesMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorGogglesListBotsResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesListBotsResponseSuccess = (vektorGogglesListBotsResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesListBotsResponse = (vektorGogglesListBotsResponseSuccess)

export const getVektorGogglesListBotsUrl = (params?: VektorGogglesListBotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vektor/bots?${stringifiedParams}` : `/api/vektor/bots`
}

export const useVektorGogglesListBotsHook = (): (params?: VektorGogglesListBotsParams, options?: RequestInit) => Promise<vektorGogglesListBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VektorGogglesListBotsParams, options?: RequestInit) => {

        return customFetcher(getVektorGogglesListBotsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorGogglesListOverlaysResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesListOverlaysResponseSuccess = (vektorGogglesListOverlaysResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesListOverlaysResponse = (vektorGogglesListOverlaysResponseSuccess)

export const getVektorGogglesListOverlaysUrl = (params?: VektorGogglesListOverlaysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vektor/bot-overlays?${stringifiedParams}` : `/api/vektor/bot-overlays`
}

export const useVektorGogglesListOverlaysHook = (): (params?: VektorGogglesListOverlaysParams, options?: RequestInit) => Promise<vektorGogglesListOverlaysResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VektorGogglesListOverlaysParams, options?: RequestInit) => {

        return customFetcher(getVektorGogglesListOverlaysUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorGogglesStreamOverlaysResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesStreamOverlaysResponseSuccess = (vektorGogglesStreamOverlaysResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesStreamOverlaysResponse = (vektorGogglesStreamOverlaysResponseSuccess)

export const getVektorGogglesStreamOverlaysUrl = (params?: VektorGogglesStreamOverlaysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vektor/bot-overlays/stream?${stringifiedParams}` : `/api/vektor/bot-overlays/stream`
}

export const useVektorGogglesStreamOverlaysHook = (): (params?: VektorGogglesStreamOverlaysParams, options?: RequestInit) => Promise<vektorGogglesStreamOverlaysResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VektorGogglesStreamOverlaysParams, options?: RequestInit) => {

        return customFetcher(getVektorGogglesStreamOverlaysUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorGogglesKickPossessorResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesKickPossessorResponseSuccess = (vektorGogglesKickPossessorResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesKickPossessorResponse = (vektorGogglesKickPossessorResponseSuccess)

export const getVektorGogglesKickPossessorUrl = (botId: string,) => {




  return `/api/vektor/possess/${botId}/kick`
}

export const useVektorGogglesKickPossessorHook = (): (botId: string, options?: RequestInit) => Promise<vektorGogglesKickPossessorResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorGogglesKickPossessorUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type vektorGogglesListStorageChestIndexResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesListStorageChestIndexResponseSuccess = (vektorGogglesListStorageChestIndexResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesListStorageChestIndexResponse = (vektorGogglesListStorageChestIndexResponseSuccess)

export const getVektorGogglesListStorageChestIndexUrl = () => {




  return `/api/vektor/storage-chests/index`
}

export const useVektorGogglesListStorageChestIndexHook = (): (vektorChestIndexRequestDto?: VektorChestIndexRequestDto, options?: RequestInit) => Promise<vektorGogglesListStorageChestIndexResponse> => {

      const customFetcher = useSfetchMutator();
      return (vektorChestIndexRequestDto?: VektorChestIndexRequestDto, options?: RequestInit) => {

        return customFetcher(getVektorGogglesListStorageChestIndexUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vektorChestIndexRequestDto)
  }
);
      }
  }


export type vektorGogglesListStorageChestContentsResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesListStorageChestContentsResponseSuccess = (vektorGogglesListStorageChestContentsResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesListStorageChestContentsResponse = (vektorGogglesListStorageChestContentsResponseSuccess)

export const getVektorGogglesListStorageChestContentsUrl = () => {




  return `/api/vektor/storage-chests/contents`
}

export const useVektorGogglesListStorageChestContentsHook = (): (vektorChestContentsRequestDto?: VektorChestContentsRequestDto, options?: RequestInit) => Promise<vektorGogglesListStorageChestContentsResponse> => {

      const customFetcher = useSfetchMutator();
      return (vektorChestContentsRequestDto?: VektorChestContentsRequestDto, options?: RequestInit) => {

        return customFetcher(getVektorGogglesListStorageChestContentsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vektorChestContentsRequestDto)
  }
);
      }
  }


export type vektorGogglesRecordObservedChestResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesRecordObservedChestResponseSuccess = (vektorGogglesRecordObservedChestResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesRecordObservedChestResponse = (vektorGogglesRecordObservedChestResponseSuccess)

export const getVektorGogglesRecordObservedChestUrl = () => {




  return `/api/vektor/storage-chests/observed`
}

export const useVektorGogglesRecordObservedChestHook = (): (vektorChestObservationRequestDto?: VektorChestObservationRequestDto, options?: RequestInit) => Promise<vektorGogglesRecordObservedChestResponse> => {

      const customFetcher = useSfetchMutator();
      return (vektorChestObservationRequestDto?: VektorChestObservationRequestDto, options?: RequestInit) => {

        return customFetcher(getVektorGogglesRecordObservedChestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vektorChestObservationRequestDto)
  }
);
      }
  }


export type vektorGogglesSubmitSchematicResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesSubmitSchematicResponseSuccess = (vektorGogglesSubmitSchematicResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesSubmitSchematicResponse = (vektorGogglesSubmitSchematicResponseSuccess)

export const getVektorGogglesSubmitSchematicUrl = () => {




  return `/api/vektor/schematics`
}

export const useVektorGogglesSubmitSchematicHook = (): (vektorSchematicSubmitRequestDto?: VektorSchematicSubmitRequestDto, options?: RequestInit) => Promise<vektorGogglesSubmitSchematicResponse> => {

      const customFetcher = useSfetchMutator();
      return (vektorSchematicSubmitRequestDto?: VektorSchematicSubmitRequestDto, options?: RequestInit) => {

        return customFetcher(getVektorGogglesSubmitSchematicUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vektorSchematicSubmitRequestDto)
  }
);
      }
  }


export type vektorGogglesListSchematicsResponse200 = {
  data: void
  status: 200
}

export type vektorGogglesListSchematicsResponseSuccess = (vektorGogglesListSchematicsResponse200) & {
  headers: Headers;
};
;

export type vektorGogglesListSchematicsResponse = (vektorGogglesListSchematicsResponseSuccess)

export const getVektorGogglesListSchematicsUrl = () => {




  return `/api/vektor/schematics`
}

export const useVektorGogglesListSchematicsHook = (): ( options?: RequestInit) => Promise<vektorGogglesListSchematicsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorGogglesListSchematicsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


